import {deleteWorkspaceUser} from "../../graphql/mutations";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";


export async function removeWorkspaceUser(
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsIdUserId: string,
    _version: number
) {
    const queryResult = await queryGqlApi(
            deleteWorkspaceUser,
            {
                input: {
                    id: wsIdUserId,
                    _version: _version,
                }
            },
            dataClientService,
            authService,
            'main'
        );
    return queryResult;
}
